export async function submitJob(apiUrl, payload) {
  const res = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    throw new Error("Job submission failed");
  }

  return res.json();
}

export async function fetchJobStatus(statusUrl) {
  const res = await fetch(statusUrl, {
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
      Accept: "application/json",
    },
  });

  if (!res.ok) {
    throw new Error("Status fetch failed");
  }

  return res.json();
}
